module.exports = __webpack_public_path__ + "images/jaguar_smallfdd3294642f49f43f25c9ddf5d6a88b7.png";